import { Injectable, EventEmitter } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { BrokerAuditDataModel } from '../../model/brokerAuditDataModel';
import { environment } from '../../../environments/environment';
import { SubmitBrokerAuditDataResponseModel } from '../../model/submitBrokerAuditDataResponseModel';
import { SubmitBrokerAuditDataRequestModel } from '../../model/submitBrokerAuditDataRequestModel';
import { WorkflowModel } from '../../model/workflowModel';
import { BadQuestionnaireModel } from '../../model/badQuestionnaireModel';
import { SubmitBrokerAuditQuestionnaireRequestModel } from '../../model/submitBrokerAuditQuestionnaireRequestModel';
import { StorageService } from '../../shared/security/StorageService';
import { StartFunctionResponseModel } from '../../model/startFunctionResponseModel';
import { BadFileModelRequest } from '../../model/badFileModelRequest';
import { retryWhen, flatMap } from 'rxjs/operators';
import { _throw as throwError } from 'rxjs/observable/throw'
import { interval } from 'rxjs/observable/interval';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';

@Injectable()
export class BrokerAuditDeclarationService {

  private notifyBrokerAuditLastUpdatedData : EventEmitter<Date> = new EventEmitter<Date>();
  private notifyBrokerAuditLastUpdatedQuestionnaire : EventEmitter<Date> = new EventEmitter<Date>();

  private notifyBrokerAuditReviewAffirmations : EventEmitter<Array<boolean>> = new EventEmitter<Array<boolean>>();
  private notifySaveData : EventEmitter<boolean> = new EventEmitter<boolean>();

  submitBrokerAuditQuestionnaireRequestModel : SubmitBrokerAuditQuestionnaireRequestModel = new SubmitBrokerAuditQuestionnaireRequestModel();
  brokerAuditDeclarationWorkflowModel : WorkflowModel;
  brokerAuditDataModel : BrokerAuditDataModel;
  badQuestionnaireDataModel : BadQuestionnaireModel = null;
  brokerDataDeclarationSectionList : Array<number> = []
  brokerADQuestionnaireSectionsList : Array<number> = [];
  constructor(private http: HttpClient,
              private storageService : StorageService) { }


  getBrokerAuditDeclarationData(workflowID: number) {
    //GET /api/BadData
    const params = new HttpParams()
      .set('workflowID', workflowID.toString());
    return this.http.get<BrokerAuditDataModel>(environment.server_url + "/api/BadData", { params });


  }
  http_retry(maxRetry: number = 2, delayMs: number = 1000) {
    console.log('In Retrying....');
    return (src: Observable<any>) => src.pipe(
      retryWhen(errors => {
        errors.subscribe(sourceError => console.log(sourceError));
        return interval(delayMs).pipe(
          flatMap(count => count == maxRetry ? throwError("Giving up") : of(count))
        )
      })
    )
  }
  submitBrokerAuditDeclarationData(submitBrokerAuditDataRequestModel: SubmitBrokerAuditDataRequestModel) {
    submitBrokerAuditDataRequestModel.BrokerAuditData.LastUpdated = new Date();
    //POST /api/BadData
    return this.http.post<SubmitBrokerAuditDataResponseModel>(environment.server_url + "/api/BadData", submitBrokerAuditDataRequestModel);

  }

  getBrokerAuditDeclarationQuestionnaire(workflowID: number) {
    //GET /api/BadQuestionnaire
    const params = new HttpParams()
      .set('workflowID', workflowID.toString());
    return this.http.get<BadQuestionnaireModel>(environment.server_url + "/api/BadQuestionnaire", { params });


  }

  submitBrokerAuditDeclarationQuestionnaire(submitbadQuestionnaireModelRequest: SubmitBrokerAuditQuestionnaireRequestModel) {
    //POST /api/BadQuestionnaire
    return this.http.post<SubmitBrokerAuditDataResponseModel>(environment.server_url + "/api/BadQuestionnaire", submitbadQuestionnaireModelRequest);

  }

  submitBadFile(badFileModelRequest:BadFileModelRequest) {
  
    return this.http.post<string>(environment.server_url + "/api/Bad", badFileModelRequest).pipe(
      this.http_retry()
    

    );
  
  }

 

  getNotifyBrokerAuditLastUpdated(){
    return this.notifyBrokerAuditLastUpdatedData;
  }

  updateStartFunction( startFunction: StartFunctionResponseModel){
    console.log("this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel : : ",this.brokerAuditDeclarationWorkflowModel);

    startFunction.Workflow.CurrentStepIndex = ( this.brokerAuditDeclarationWorkflowModel.CurrentStepIndex ?  this.brokerAuditDeclarationWorkflowModel.CurrentStepIndex : null);
    startFunction.Workflow.WorkflowID = ( this.brokerAuditDeclarationWorkflowModel.WorkflowID ?  this.brokerAuditDeclarationWorkflowModel.WorkflowID : null);
    startFunction.Workflow.WorkflowDisplayName = ( this.brokerAuditDeclarationWorkflowModel.WorkflowDisplayName ?  this.brokerAuditDeclarationWorkflowModel.WorkflowDisplayName : null);
    startFunction.Workflow.Fees = ( this.brokerAuditDeclarationWorkflowModel.Fees ?  this.brokerAuditDeclarationWorkflowModel.Fees : null);
    for (let i = 0; i <  this.brokerAuditDeclarationWorkflowModel.Steps.length; i++) {
      startFunction.Workflow.Steps[i].StepDisplayName =  this.brokerAuditDeclarationWorkflowModel.Steps[i].StepDisplayName;
      startFunction.Workflow.Steps[i].StepMessage =  this.brokerAuditDeclarationWorkflowModel.Steps[i].StepMessage;
      startFunction.Workflow.Steps[i].WorkflowStepStatus =  this.brokerAuditDeclarationWorkflowModel.Steps[i].WorkflowStepStatus;
      startFunction.Workflow.Steps[i].WorkflowStepType =  this.brokerAuditDeclarationWorkflowModel.Steps[i].WorkflowStepType;

    }
    this.storageService.setStartFunctionData(startFunction);
  }

  getNotifyBrokerAuditReviewAffirmations(){
    return this.notifyBrokerAuditReviewAffirmations;
  }

  getNotifyBrokerAuditLastUpdatedQuestionnaire(){
    return this.notifyBrokerAuditLastUpdatedQuestionnaire;
  }

  clearBrokerAuditDeclarationService(){
    this.brokerAuditDeclarationWorkflowModel = null;
    this.brokerAuditDataModel = null;
    this.badQuestionnaireDataModel = null;
    this.brokerDataDeclarationSectionList = [];
    this.brokerADQuestionnaireSectionsList = [];
  }

  getNotifySaveData(){
    return this.notifySaveData;
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/broker-audit-declaration.service.ts